import React, { useState } from 'react';
import styled from 'styled-components';
import { Flex } from './shared/Flex';
import IntroAnimation from './IntroAnimation';

const Container = styled(Flex)`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem 0px;
  flex-direction: column;
`;

const Content = styled.div`
  background: white;
  padding: 3rem;
  border-radius: 12px;
  max-width: 800px;
  width: 90%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  color: #333;
  margin-bottom: 2rem;
  font-size: 2.5rem;
  text-align: center;
`;

const StepContainer = styled.div`
  margin-bottom: 2rem;
  display: flex;
  align-items: flex-start;
  gap: 1rem;
`;

const StepNumber = styled.span`
  background-color: #004995;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 1.2rem;
  font-weight: bold;
`;

const StepContent = styled.div`
  flex: 1;
`;

const StepTitle = styled.h3`
  color: #333;
  margin-bottom: 0.5rem;
  font-size: 1.3rem;
`;

const StepDescription = styled.p`
  color: #666;
  font-size: 1.1rem;
  line-height: 1.6;
`;

const ImageContainer = styled.div`
  margin: 2rem 0;
  text-align: center;
  img {
    max-width: 100%;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;

interface TutorialPageProps {
  onComplete: () => void;
}

const TutorialPage: React.FC<TutorialPageProps> = () => {
  
  const [showIntro, setShowIntro] = useState(true);
  
  const handleStart = () => {
    setShowIntro(false);
      // Here you can navigate to the next part of your application
      // e.g., using React Router, or by rendering another component
    console.log("Animation started! Proceed to the main app.");
  };

  return (
    <div>
    <Container>
        <IntroAnimation onStart={handleStart}/>
    </Container>
    </div>
  );
};

export default TutorialPage;
